import React, { useState } from "react";

const ModeratorApplication = () => {
  const [formData, setFormData] = useState({
    name: "",
    discord: "",
    age: "",
    timezone: "",
    previousExperience: "",
    whyModerator: "",
    availability: "",
  });

  const [status, setStatus] = useState({ message: "", type: "" });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const webhookURL =
      "https://discord.com/api/webhooks/1375124182790176819/wiP6sPuAj2mHfQwbBzoJCSlgxtMtZ0p4qGKg_nW8obXnP2GuMTwnBWy7p3w80y26rDmk";

    const embedPayload = {
      embeds: [
        {
          title: "🛡️ New Moderator Application",
          color: 0x5865f2,
          fields: [
            { name: "Minecraft Username", value: formData.name || "N/A" },
            { name: "Discord Tag", value: formData.discord || "N/A" },
            { name: "Age", value: formData.age || "N/A" },
            { name: "Timezone", value: formData.timezone || "N/A" },
            { name: "Previous Experience", value: formData.previousExperience || "N/A" },
            { name: "Why Mod?", value: formData.whyModerator || "N/A" },
            { name: "Availability", value: formData.availability || "N/A" },
          ],
          footer: {
            text: "RixxyMC Staff Applications",
          },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const res = await fetch(webhookURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(embedPayload),
      });

      if (!res.ok) throw new Error("Webhook submission failed");

      setStatus({ message: "✅ Application submitted successfully!", type: "success" });

      setFormData({
        name: "",
        discord: "",
        age: "",
        timezone: "",
        previousExperience: "",
        whyModerator: "",
        availability: "",
      });
    } catch (err) {
      setStatus({ message: "❌ Submission failed. Please try again later.", type: "error" });
    }
  };

  return (
    <div className="container">
      <h2>Moderator Application</h2>
      <p>Apply to become a moderator on RixxyMC.</p>

      {status.message && (
        <div style={{ marginTop: "1rem", color: status.type === "success" ? "green" : "red" }}>
          {status.message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Minecraft Username:</label>
        <input
          type="text"
          id="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Your Minecraft Username"
          required
        />

        <label htmlFor="discord">Discord Tag (e.g. user#1234):</label>
        <input
          type="text"
          id="discord"
          value={formData.discord}
          onChange={handleChange}
          placeholder="Your Discord Tag"
          required
        />

        <label htmlFor="age">Age:</label>
        <input
          type="number"
          id="age"
          value={formData.age}
          onChange={handleChange}
          placeholder="Your age"
          min="13"
          required
        />

        <label htmlFor="timezone">Timezone:</label>
        <input
          type="text"
          id="timezone"
          value={formData.timezone}
          onChange={handleChange}
          placeholder="e.g. IST, PST"
          required
        />

        <label htmlFor="previousExperience">Previous Moderation Experience:</label>
        <textarea
          id="previousExperience"
          rows="4"
          value={formData.previousExperience}
          onChange={handleChange}
          placeholder="Describe any past moderation experience"
          required
        ></textarea>

        <label htmlFor="whyModerator">Why do you want to be a moderator?</label>
        <textarea
          id="whyModerator"
          rows="4"
          value={formData.whyModerator}
          onChange={handleChange}
          placeholder="Tell us your motivation"
          required
        ></textarea>

        <label htmlFor="availability">When are you usually available?</label>
        <textarea
          id="availability"
          rows="3"
          value={formData.availability}
          onChange={handleChange}
          placeholder="Days/times you can moderate"
          required
        ></textarea>

        <button type="submit">Submit Application</button>
      </form>
    </div>
  );
};

export default ModeratorApplication;
